export default class QueriesController {
  _requestService;
  _paths;
  constructor(requestService, paths) {
    this._requestService = requestService;
    this._paths = paths;
  }

  async fetchMotivationalMessage() {
    return await this._requestService.Get(this._paths.MOTIVATIONAL_MESSAGE_PATH);
  }

  async fetchAboutUs() {
    const path = this._paths.ABOUT_US;
    const { data } = await this._requestService.Get(path);
    return data.about_us;
  }

  async fetchAboutFaqs(queryParams) {
    try {
      const path = this._paths.ABOUT_FAQS(queryParams);
      const { data } = await this._requestService.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, the FAQS could not be obtained.');
    }
  }

  async fetchFAQSTopics() {
    try {
      const path = this._paths.FAQS_TOPICS;
      const { data } = await this._requestService.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, we had a problem getting the topics.');
    }
  }

  async settingsFetchTimeZones() {
    const path = this._paths.SETTINGS_TIMEZONES;
    const { data } = await this._requestService.Get(path);
    return data;
  }

  async settingsFetchTimeZone({ isParent, userId }) {
    const path = this._paths.SETTINGS_GET_TIMEZONE_SETUP(isParent, userId);
    const { data } = await this._requestService.Get(path);
    return data.value;
  }

  async settingFecthNotificationSetup({ isParent, userId }) {
    const path = this._paths.SETTINGS_NOTIFICATION_SETUP(isParent, userId);
    const { data } = await this._requestService.Get(path);
    return data;
  }

  async fetchTips() {
    const path = this._paths.GET_TIPS;
    const { data } = await this._requestService.Get(path);
    return data;
  }

  async fetchParentByEmail({ email }) {
    try {
      const path = this._paths.GET_PARENT_BY_EMAIL(email);
      const { data } = await this._requestService.Get(path);
      return data;
    } catch (error) {
      throw new Error('[Query]: Sorry, unregistered parent.');
    }
  }
}

